import React from 'react';
import { motion } from 'framer-motion';
export function Section9() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="bg-[#4DC61A]/5 py-16" data-id="element-240">
      <div className="max-w-3xl mx-auto px-6" data-id="element-241">
        <h2 className="font-sans font-bold text-4xl text-[#0F4226] mb-12 text-center" data-id="element-242">
          9. What You Get
        </h2>

        <div className="mb-12" data-id="element-243">
          <img src="https://cdn.magicpatterns.com/uploads/gHQRoX2XtdcpXsSKQ4VpU9/AI-Generated-Image-4_(8).png" alt="FLO product — never worry about fleas again, natural 12-month protection with before and after comparison" className="w-full rounded shadow-md" data-id="element-244" />
        </div>

        <div className="space-y-6 mb-12" data-id="element-245">
          <div className="bg-white p-8 rounded shadow-lg border-2 border-[#4DC61A]" data-id="element-246">
            <div className="flex items-start gap-6" data-id="element-247">
              <img src="https://placehold.co/120x120/ffffff/2d5a2d?text=FLO" alt="FLO Pendant" className="rounded" data-id="element-248" />
              <div className="flex-1" data-id="element-249">
                <h3 className="font-sans font-bold text-2xl mb-2 text-[#0F4226]" data-id="element-250">
                  FLO Natural Flea & Tick Repellent Pendant
                </h3>
                <p className="font-sans text-lg text-[#666666] mb-4" data-id="element-251">
                  12 months of continuous passive protection. Waterproof. Works
                  for dogs and cats of all sizes.
                </p>
                <p className="font-sans font-bold text-3xl text-[#4DC61A]" data-id="element-252">
                  $39.99
                </p>
                <p className="text-[#666666]" data-id="element-253">Just $3.34 per month</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded shadow-md border-l-4 border-[#4DC61A]" data-id="element-254">
            <h3 className="font-sans font-bold text-xl mb-2 text-[#0F4226]" data-id="element-255">
              FREE BONUS: The Natural Pet Parent's Complete Flea & Tick Field
              Guide
            </h3>
            <p className="font-sans text-[#666666] mb-2" data-id="element-256">
              Tick removal protocol, natural yard treatment guide, what to do if
              you find a tick, seasonal risk by region.
            </p>
            <p className="text-sm text-[#666666]" data-id="element-257">
              <span className="line-through" data-id="element-258">$27 value</span> — Yours free with
              purchase
            </p>
          </div>

          <div className="bg-[#0F4226] text-white p-8 rounded shadow-lg" data-id="element-259">
            <h3 className="font-sans font-bold text-2xl mb-4" data-id="element-260">
              Multi-Pet Pricing Available
            </h3>
            <p className="font-sans text-lg text-white/90" data-id="element-261">
              Protecting more than one pet? Get additional pendants at a
              discount. Pricing shown at checkout.
            </p>
          </div>
        </div>

        <div className="bg-[#4DC61A] text-white p-10 rounded shadow-2xl" data-id="element-262">
          <h3 className="font-sans font-bold text-3xl mb-6 text-center" data-id="element-263">
            The 60-Day FLO Guarantee
          </h3>
          <p className="font-sans text-xl leading-relaxed text-center mb-6" data-id="element-264">
            If your pet gets a single flea or tick while wearing FLO in the
            first 60 days, contact us for a complete refund.
          </p>
          <div className="text-center space-y-2" data-id="element-265">
            <p className="font-sans font-bold text-lg" data-id="element-266">No questions.</p>
            <p className="font-sans font-bold text-lg" data-id="element-267">No return required.</p>
            <p className="font-sans font-bold text-lg" data-id="element-268">No fine print.</p>
          </div>
          <p className="font-sans text-lg mt-6 text-center italic opacity-90" data-id="element-269">
            We're that confident — because we've seen what FLO does for 50,000+
            pets and we know it will do the same for yours.
          </p>
        </div>

        <div className="text-center mt-12" data-id="element-270">
          <a href="https://zenessa.shop/products/pet-flea-collar" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4DC61A] hover:bg-[#43b016] text-white font-sans font-bold text-xl px-10 py-4 rounded-[100px] shadow-lg transition-all duration-200" data-id="element-271">
            Try FLO Risk-Free
          </a>
        </div>
      </div>
    </motion.section>;
}